(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[679],{

/***/ 1834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts",
      function () {
        return __webpack_require__(2478);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ Post_Post; },
  "V": function() { return /* reexport */ Posts_Posts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
// EXTERNAL MODULE: ./src/components/index.ts + 50 modules
var components = __webpack_require__(2836);
// EXTERNAL MODULE: ./src/helpers/getPostTitle.ts
var getPostTitle = __webpack_require__(4441);
// EXTERNAL MODULE: ./src/helpers/getPostUrl.ts
var getPostUrl = __webpack_require__(4663);
;// CONCATENATED MODULE: ./src/page-components/posts/Post/Post.tsx







var Post = function(param) {
    var post = param.post;
    var ref;
    if (!post) return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
        children: "Cannot retrieve post data"
    });
    var postTitle = (0,getPostTitle/* default */.Z)((ref = post.postTitle) === null || ref === void 0 ? void 0 : ref.document);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* MainLayout */.Zn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: postTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: (0,getPostUrl/* default */.Z)(post.slug)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: postTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: postTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://res.cloudinary.com/hfq3eckim/image/upload/v1644397231/cms-demo/Projects%20Thumbnails/post-default_pmwqzi.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
                maxW: "container.xl",
                minH: "calc(100vh - 100px)",
                children: post && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PostView */.Ij, {
                    post: post
                })
            })
        ]
    });
};
/* harmony default export */ var Post_Post = (Post);

;// CONCATENATED MODULE: ./src/page-components/posts/Post/index.ts


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
;// CONCATENATED MODULE: ./src/page-components/posts/Posts/Posts.tsx






var Posts = function(props) {
    var ref;
    var postItems = (ref = props.allPost) === null || ref === void 0 ? void 0 : ref.map(function(post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* LinkBox */.fG, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/posts/".concat(post.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* LinkOverlay */.AB, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PostCard */.y4, {
                        postTitle: post.postTitle,
                        slug: post.slug,
                        tag: post.type,
                        views: post.views,
                        publishDate: post.publishDate,
                        outlineColor: post.outlineColor,
                        highlightColor: post.highlightColor
                    })
                })
            })
        }, post.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* MainLayout */.Zn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Posts | Chacra Software Solutions"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                maxWidth: "container.xl",
                textAlign: "left",
                py: 20,
                minH: "100vh",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        as: "h1",
                        fontSize: "6xl",
                        mb: "4",
                        children: "Blogs & Articles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "xl",
                        mb: "8",
                        children: "We stay up to date with the latest technologies and industry news by researching and summarizing what we find in the simplest terms possible. If you can't explain something simply then you simply don't understand it well enough."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
                        templateColumns: {
                            base: 'repeat(1,1fr)',
                            md: 'repeat(2,1fr)',
                            lg: 'repeat(3,1fr)'
                        },
                        gap: "10",
                        children: postItems && postItems
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Posts_Posts = (Posts);

;// CONCATENATED MODULE: ./src/page-components/posts/Posts/index.ts


;// CONCATENATED MODULE: ./src/page-components/posts/index.ts




/***/ }),

/***/ 2478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _page_components_posts__WEBPACK_IMPORTED_MODULE_0__.V; }
/* harmony export */ });
/* harmony import */ var _page_components_posts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7415);
var __N_SSG = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,13,234,5,25,774,888,179], function() { return __webpack_exec__(1834); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);